declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
    dataLayer?: unknown[]
  }
}

export type SimulateLocation = 'hero' | 'header_nav' | 'how_it_works' | 'faq'
export type ContactLocation =
  | 'header'
  | 'cta_section'
  | 'floating_button'
  | 'calculator_result'
  | 'mobile_nav'
  | 'footer'
  | 'how_it_works'
  | 'faq'
export type SavingsTier = 'none' | 'low' | 'medium' | 'high'

export function isAnalyticsEnabled(): boolean {
  return (
    !import.meta.env.DEV &&
    typeof import.meta.env.VITE_GA_MEASUREMENT_ID === 'string' &&
    import.meta.env.VITE_GA_MEASUREMENT_ID.length > 0
  )
}

export function getSavingsTier(savings: number): SavingsTier {
  if (savings <= 0) return 'none'
  if (savings < 10_000) return 'low'
  if (savings < 50_000) return 'medium'
  return 'high'
}

function gtag(...args: unknown[]) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args)
  }
}

export function trackPageView(path: string) {
  if (!isAnalyticsEnabled()) return
  gtag('event', 'page_view', { page_path: path })
}

export function trackEvent(
  name: string,
  params?: Record<string, string | number | boolean>,
) {
  if (!isAnalyticsEnabled()) return
  gtag('event', name, params)
}

export function trackSimulateClick(location: SimulateLocation) {
  trackEvent('cta_simulate_click', { location })
}

export function trackContactClick(
  method: 'whatsapp' | 'email',
  location: ContactLocation,
) {
  trackEvent('cta_contact_click', { method, location })
}

export function trackCalculatorSubmit(
  hasIncomeInput: boolean,
  savingsTier: SavingsTier,
) {
  trackEvent('calculator_submit', {
    has_income_input: hasIncomeInput,
    savings_tier: savingsTier,
  })
}

export function trackCalculatorResultShown(savingsTier: SavingsTier) {
  trackEvent('calculator_result_shown', { savings_tier: savingsTier })
}
